import React from 'react';
import { cn } from '../utils/cn';
export const DescriptionList = React.forwardRef(function DescriptionList(
  { items, columns = 2, className, ...props },
  ref,
) {
  return (
    <dl
      ref={ref}
      className={cn(
        'grid gap-x-6 gap-y-4',
        columns === 1 && 'grid-cols-1',
        columns === 2 && 'grid-cols-1 sm:grid-cols-2',
        columns === 3 && 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
        className,
      )}
      {...props}
    >
      {items.map((item) => (
        <div key={item.term}>
          <dt className="text-sm font-medium text-fg-tertiary">{item.term}</dt>
          <dd className="mt-1 text-sm text-fg">{item.detail}</dd>
        </div>
      ))}
    </dl>
  );
});
